import RenderToast from "@/components/RenderToast";
import { extractErrors } from "@/utils/helper";
import { useEffect } from "react";

const useHttpErrorToast = (error) => {
  useEffect(() => {
    if (error && error.status === 422 && Object.keys(error.response.data.errors).length) {
      const errorMessages = extractErrors(error.response.data.errors);
      RenderToast({ type: "error", message: errorMessages });
    }
  }, [error]);
};

export default useHttpErrorToast;
